type OlderHistoryNoticeInput = {
  includedDays: number;
  canEditBilling: boolean;
};

export type OlderHistoryNoticeText = {
  title: string;
  body: string;
};

/** The text of the notice at the end of a list that stops at the included window. */
export function olderHistoryNoticeText({
  includedDays,
  canEditBilling,
}: OlderHistoryNoticeInput): OlderHistoryNoticeText {
  const remedy = canEditBilling
    ? 'Subscribe to the data retention add-on'
    : 'Ask an admin to subscribe to the data retention add-on';
  return {
    title: `Activity is limited to the last ${includedDays} days.`,
    body: `Nothing is deleted. ${remedy} to see activity older than ${includedDays} days.`,
  };
}
